import { HStack, Image, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { colors } from "../../styles";
import { formatPrice } from "../../utils";

interface IMiniMedListItemProps {
    seller:string | null;
    medicineImage:string | null;
    medicineName:string | null;
    packageUnit:string | null;
    ingredientInfo:string | null;
}

function MiniMedListItem({ seller, medicineImage, medicineName, packageUnit, ingredientInfo}:IMiniMedListItemProps) {

    /* miniMedicineName */

    const miniMedicineName = useMemo(() => {
        return medicineName ? medicineName.split('(')[0].trim() : "-";
    }, [medicineName]);

            

    /* render */

    return (
        <HStack width={"100%"} justifyContent={"space-between"}>

            {/* 상품 정보 */}

            <HStack width={"100%"} justifyContent={"flex-start"} alignItems={"center"}>

                {/* 상품 이미지 */}

                {medicineImage ? (
                    <Image 
                        src={medicineImage.split(";")[0]} 
                        alt="miniMedicineImage" 
                        width={36} 
                        height={36}
                        border={"0.5px solid " + colors.g4}
                        borderRadius={10}
                        objectFit={"contain"}
                    />
                ) : (
                    <Image 
                        src="/png/nutrients.png" 
                        alt="miniMedicineImage" 
                        width={36} 
                        height={36}
                        border={"0.5px solid " + colors.g4}
                        borderRadius={10}
                        objectFit={"contain"}
                    />
                )}
            

                {/* 상품 정보 - 상품명, 포장 단위 */}

                <VStack 
                    justifyContent={"center"}
                    alignItems={"flex-start"}
                    marginLeft={5}
                    spacing={2}
                >
                    <Text fontSize={14} fontWeight={700} color={colors.g3}>{seller ?? "-"}</Text>
                    <Text fontSize={16} fontWeight={700} color={colors.g1}>{miniMedicineName}</Text>
                    <Text fontSize={14} fontWeight={400} color={colors.g3}>{(!packageUnit || packageUnit === "NULL") ? "-" : packageUnit}</Text>
                    <Text fontSize={12} fontWeight={400} color={colors.g1}>{ingredientInfo ?? "-"}</Text>
                </VStack>
            </HStack>
        </HStack>
    )
}

export default React.memo(MiniMedListItem);